import React, { useState } from 'react'
import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import { useAccount, useBalance, useNetwork, useSwitchNetwork } from 'wagmi'
import { useWeb3Modal } from '@web3modal/wagmi/react'
import './Header.css'
import logo from '../Assets/ip-gif.gif'
import { AiOutlineMenu } from 'react-icons/ai'
import { RxCross2 } from 'react-icons/rx'
export default function Header() {
  const { chain } = useNetwork()
  const { chains, switchNetwork } = useSwitchNetwork()
  const { address } = useAccount()
  const { open } = useWeb3Modal()

  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  return (
    <div>
      <Navbar collapseOnSelect expand="lg" className="main_Nav">
        <Container>
          <Navbar.Brand href="/" className="main_logo">
            <img src={logo} alt="" />
          </Navbar.Brand>
          <span className="d-block d-lg-none" onClick={() => setShow(!show)}>
            {show ? (
              <>
                <RxCross2 className="text-white fs-1" />{' '}
              </>
            ) : (
              <>
                <AiOutlineMenu className="text-white fs-1" />
              </>
            )}
          </span>

          <Navbar.Collapse id="responsive-navbar-nav" className={show ? 'show' : ''}>
            <Nav className="m-auto gap-2">
              <Nav.Link onClick={handleClose} href="/#Home">
                Home
              </Nav.Link>
              <Nav.Link onClick={handleClose} href="/#Roadmap">
                Roadmap
              </Nav.Link>
              <Nav.Link onClick={handleClose} href="/#Tokenomics">
                Tokenomics
              </Nav.Link>
              <Nav.Link onClick={handleClose} href="/Whitepaper.pdf">
                Whitepaper
              </Nav.Link>
              <Nav.Link onClick={handleClose} href="https://defi.ip2025.biz">
                DeFi
              </Nav.Link>
              <Nav.Link onClick={handleClose} href="/Mining">
                MINING
              </Nav.Link>
              <Nav.Link onClick={handleClose} href="/swap">
                SWAP IP
              </Nav.Link>
              <Nav.Link onClick={handleClose} href="/ipcswap">
                SWAP IPC
              </Nav.Link>
            </Nav>
            <Nav>
              <div className="d-flex justify-content-center mt-3">
                <button
                  className="button-5 sus py-2 w-100"
                  onClick={() =>
                    address
                      ? chain?.id == chains[0]?.id
                        ? open()
                        : switchNetwork?.(chains[0]?.id)
                      : open()
                  }
                >
                  {/* <img src={buybtn} alt="" /> */}

                  {address ? (
                    chain?.id == chains[0]?.id || chain?.id == chains[1]?.id ? (
                      address ? (
                        <>
                          {`${address?.substring(0, 6)}...${address?.substring(
                            address.length - 4,
                          )}`}
                        </>
                      ) : (
                        <>Connect Wallet</>
                      )
                    ) : (
                      'Switch Network'
                    )
                  ) : (
                    <>Connect Wallet</>
                  )}
                </button>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  )
}
